<div class="container mt-4">
  <h2>{{ isEditMode ? 'Modifier un Produit' : 'Créer un Nouveau Produit' }}</h2>

  <div *ngIf="successMessage" class="alert alert-success">
    {{ successMessage }}
  </div>
  <div *ngIf="errorMessage" class="alert alert-danger">
    {{ errorMessage }}
  </div>

  <form [formGroup]="productForm" (ngSubmit)="onSubmit()" enctype="multipart/form-data">
    <div class="input-container">
      <label for="title">Titre<span class="text-danger">*</span></label>
      <input id="title" type="text" class="form-control" formControlName="title" [ngClass]="{'is-invalid': submitted && f['title'].errors}" />
      <div *ngIf="submitted && f['title'].errors" class="invalid-feedback">
        <div *ngIf="f['title'].errors['required']">Le titre est requis.</div>
      </div>
    </div>
    <div class="input-container">
      <label for="slug">Slug<span class="text-danger">*</span></label>
      <input id="slug" type="text" class="form-control" formControlName="slug" [ngClass]="{'is-invalid': submitted && f['slug'].errors}" />
      <div *ngIf="submitted && f['slug'].errors" class="invalid-feedback">
        <div *ngIf="f['slug'].errors['required']">Le slug est requis.</div>
      </div>
    </div>

    <div class="input-container">
      <label for="specs">Spécifications</label>
      <textarea id="specs" class="form-control" formControlName="specs" rows="3"></textarea>
    </div>

    <div class="input-container form-check">
      <input id="status" type="checkbox" class="form-check-input" formControlName="status" />
      <label class="form-check-label" for="status">Prévente</label>
    </div>

    <div class="input-container form-check">
      <input id="isFeatured" type="checkbox" class="form-check-input" formControlName="isFeatured" />
      <label class="form-check-label" for="isFeatured">Sur Mesure</label>
    </div>

    <div class="input-container">
      <label for="debut">Début</label>
      <input id="debut" type="date" class="form-control" formControlName="debut" />
    </div>

    <div class="input-container">
      <label for="fin">Fin</label>
      <input id="fin" type="date" class="form-control" formControlName="fin" />
    </div>

    <div class="input-container">
      <label for="categoryId">Catégorie<span class="text-danger">*</span></label>
      <select id="categoryId" class="form-control" formControlName="categoryId" [ngClass]="{'is-invalid': submitted && f['categoryId'].errors}">
        <option value="">Sélectionnez une catégorie</option>
        <option *ngFor="let category of categories" [value]="category.id">{{ category.title }}</option>
      </select>
      <div *ngIf="submitted && f['categoryId'].errors" class="invalid-feedback">
        <div *ngIf="f['categoryId'].errors['required']">La catégorie est requise.</div>
      </div>
    </div>

    <div class="input-container">
      <label for="brandId">Marque<span class="text-danger">*</span></label>
      <select id="brandId" class="form-control" formControlName="brandId" [ngClass]="{'is-invalid': submitted && f['brandId'].errors}">
        <option value="">Sélectionnez une marque</option>
        <option *ngFor="let brand of brands" [value]="brand.id">{{ brand.title }}</option>
      </select>
      <div *ngIf="submitted && f['brandId'].errors" class="invalid-feedback">
        <div *ngIf="f['brandId'].errors['required']">La marque est requise.</div>
      </div>
    </div>

    <div class="input-container">
      <label for="gltfPath">Fichier GLTF</label>
      <input type="file" (change)="onFileChange($event, 'gltfPath')" #gltfInput class="form-control-file" />
      <div *ngIf="gltfUrl">
        <img [src]="gltfUrl" alt="GLTF Preview" style="width: 100px; height: auto;" />
      </div>
    </div>

    <div class="input-container">
      <label for="binPath">Fichier BIN</label>
      <input type="file" (change)="onFileChange($event, 'binPath')" #binInput class="form-control-file" />
      <div *ngIf="binUrl">
        <img [src]="binUrl" alt="BIN Preview" style="width: 100px; height: auto;" />
      </div>
    </div>

    <div class="input-container">
      <label for="texturePath">Fichier de Texture</label>
      <input type="file" (change)="onFileChange($event, 'texturePath')" #textureInput class="form-control-file" />
      <div *ngIf="textureUrl">
        <img [src]="textureUrl" alt="Texture Preview" style="width: 100px; height: auto;" />
      </div>
    </div>

    <button type="submit" class="btn btn-primary">{{ isEditMode ? 'Mettre à jour le Produit' : 'Créer le Produit' }}</button>
    <button type="button" class="btn btn-secondary" (click)="resetForm()">Annuler</button>
  </form>

  <h3 class="mt-4">Liste des Produits</h3>
  <table class="table table-bordered">
    <thead>
      <tr>
        <th>ID</th>
        <th>Titre</th>
        <th>Fichier GLTF</th>
        <th>Fichier de Texture</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let product of products">
        <td>{{ product.id }}</td>
        <td>{{ product.title }}</td>
        <td>
          <img *ngIf="getImageUrl(product.gltfPath)" [src]="getImageUrl(product.gltfPath)" alt="GLTF Model" style="width: 100px; height: auto;" />
        </td>
        <td>
          <img *ngIf="getImageUrl(product.texturePath)" [src]="getImageUrl(product.texturePath)" alt="Texture Image" style="width: 100px; height: auto;" />
        </td>
        <td>
          <button class="btn btn-warning" (click)="prepareEdit(product)">Modifier</button>
          <button class="btn btn-danger"
                  (click)="product.id !== undefined ? deleteProduct(product.id) : null">
            Supprimer
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</div>
